module.exports = __webpack_public_path__ + "static/media/day11.443c64c1.jpg";